import { IconFileCheck, IconInfoCircleFilled } from '@tabler/icons-react';
import React from 'react';
import classNames from 'classnames';
import { NSCard } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import { PROJECT_ACTUALS_ICON_WITH_TOOLTIP_TEXT } from 'views/ProFormaTable/constants';
import IconWithTooltip from '../../../../components/IconWithTooltip/IconWithTooltip';

export interface IMetricOutputCardProps {
    label: string | React.ReactNode;
    showInProgress?: boolean;
    value?: string | number | React.ReactNode;
    showProjectActualsIcon?: boolean;
    projectActualsIconName?: string;
    inProgressText?: string | React.ReactNode;
    tooltipText?: string;
    tooltipIconName?: string;
    cardClassName?: string;
}

const MetricOutputCard = ({
    showInProgress, label, value, showProjectActualsIcon, projectActualsIconName,
    inProgressText, tooltipText, tooltipIconName, cardClassName = '',
}: IMetricOutputCardProps) => (
    <NSCard className={classNames('NSCard--level-3 h-100', cardClassName || 'p-2')}>
        <div>
            <div className="d-flex align-items-center">
                <RenderIf isTrue={showProjectActualsIcon}>
                    <IconWithTooltip
                        name={projectActualsIconName!}
                        icon={IconFileCheck}
                        tooltipText={PROJECT_ACTUALS_ICON_WITH_TOOLTIP_TEXT}
                        className="my-auto mr-1"
                    />
                </RenderIf>
                <span className="mb-0">{label}</span>
                <RenderIf isTrue={!!tooltipText}>
                    <IconWithTooltip
                        name={tooltipIconName || 'metric-tooltip'}
                        icon={IconInfoCircleFilled}
                        tooltipText={tooltipText!}
                        className="ml-1"
                    />
                </RenderIf>
            </div>
            <RenderIf isTrue={!showInProgress}>
                <div className="mb-0 text-dark">
                    {value}
                </div>
            </RenderIf>
            <RenderIf isTrue={showInProgress}>
                <p className="mb-0 text-dark font-italic">{inProgressText || 'In progress'}</p>
            </RenderIf>
        </div>
    </NSCard>
);

export default MetricOutputCard;
